import React from "react";
import { Calendar } from "primereact/calendar";
import { useField } from "formik";

// Define shared pt object
const sharedPt = {
  root: { className: 'input-field !text-[12px]' },
  input: {
    root: {
      className:
        '!p-0 border-0 !bg-transparent !shadow-none w-full h-full !focus:border-0 !focus:outline-none focus:shadow-none !focus:ring-0 !text-[12px]'
    }
  },
  panel: { className: '!min-w-[250px] !w-auto' },
  dayLabel: { className: 'w-[25px] h-[25px] text-[14px]' },
  tableheadercell: { className: '!p-1 text-[14px]' },
  todayButton: { label: { className: '!text-primary !font-[500]' } },
  clearButton: { label: { className: '!text-primary !font-[500]' } }
}
// DatePicker component for Formik usage
const FormikDatePicker = ({
  name,
  label = "",
  placeholder = "",
  className = "",
  showTime = false,
  hourFormat = "24",
  dateFormat = "dd/mm/yy",
  defaultValue = "",
  timeOnly = false,
  ...props
}) => {
  const [field, meta] = useField(name);

  return (
    <div className={`flex flex-col gap-1 w-full mb-1 ${className}`}>
      {label && (
        <label htmlFor={name} className="input-label">
          {label}
        </label>
      )}
      <Calendar
        timeOnly={timeOnly}
        id={name}
        placeholder={placeholder}
        showTime={showTime}
        hourFormat={hourFormat}
        dateFormat={dateFormat}
        value={field?.value}
        {...field}
        {...props}
        pt={sharedPt}
      />
      {meta.error && meta.touched && typeof meta.error === 'string' && (
        <p className="text-sm text-red-500">{meta.error}</p>
      )}
    </div>
  );
};

// Standalone DatePicker component
const StandaloneDatePicker = ({
  label = "",
  placeholder = "",
  className = "",
  defaultValue = "",
  showTime = false,
  hourFormat = "24",
  dateFormat = "dd/mm/yy",
  value = null,
  onChange = () => { },
  ...props
}) => {
  return (
    <div className={`flex flex-col gap-1 w-full mb-1 ${className}`}>
      {label && (
        <label
          htmlFor="standalone-date-picker"
          className="text-[11px] md:text-[12px] font-[400] text-gray-900 mb-1 capitalize"
        >
          {label}
        </label>
      )}
      <Calendar
        id="standalone-date-picker"
        placeholder={placeholder}
        showTime={showTime}
        hourFormat={hourFormat}
        dateFormat={dateFormat}
        value={value}
        onChange={onChange}
        {...props}
        pt={sharedPt}
      />
    </div>
  );
};

// DatePicker wrapper
const DatePicker = (props) => {
  const { useFormik = true } = props;

  if (useFormik) {
    return <FormikDatePicker {...props} />;
  }

  return <StandaloneDatePicker {...props} />;
};

export default DatePicker;
